import {Component, OnInit} from '@angular/core';
import {StoreService} from "../../../../../shared/services/store.service";
import {NavigationEnd, Router} from "@angular/router";
import {CartService} from "../../../../../shared/services/payment-area/cart.service";
import {DebtPositionsService} from "../../../../../shared/services/personal-area/debt-positions/debt-positions.service";
import {AuthService} from "../../../../../shared/services/auth/auth.service";
import {UserService} from "../../../../../shared/services/user.service";
import { Subject, takeUntil } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailValidator } from 'projects/frontend/src/app/shared/validators/email.validator';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserProfile } from 'projects/frontend/src/app/shared/models/personal-area/user/user-profile';
import { ModalService } from 'projects/frontend/src/app/shared/services/modal.service';

export const pathSegmentContainsPersonalRoute = '/personal';

@Component({
    selector: 'private-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class PrivateFooterComponent implements OnInit {
  isLogged$ = this.authService.isLogged$;
  isPersonalRoute: boolean = false;
  private destroyed = new Subject<void>();

  anonimousEmailForm: FormGroup;

  constructor(
    public router: Router,
    private _formBuilder: FormBuilder,
    public storeService: StoreService,
    public authService: AuthService,
    public cartService: CartService,
    public debtPositionsService: DebtPositionsService,
    public userService: UserService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private modalService: ModalService
  ) {
    this.isPersonalRoute = this.isPersonalRouteCalc(this.router.url)
    this.router.events
      .pipe(takeUntil(this.destroyed))
      .subscribe(e => this.isPersonalRoute = e instanceof NavigationEnd ?
        this.isPersonalRouteCalc(e.url) :
        false
      )

    this.anonimousEmailForm = this._formBuilder.group({
      emailAddress: [
        '',
        [Validators.required, Validators.email, Validators.maxLength(50)]
      ],
      confirmEmailAddress: [
        '',
        [
            Validators.required,
            Validators.email,
            EmailValidator('emailAddress'),
            Validators.maxLength(50)
        ]
      ]
    });
  }

  isPersonalRouteCalc = (url: string) => {
    return url.includes(pathSegmentContainsPersonalRoute) || (url.includes('payment-return') && this.authService.isLogged())
  }
  getRoute(isPersonalRoute: boolean) {
    const isLogged = this.authService.isLogged();
    let routeUrl = '/personal/payment-area/cart';
    if(!isLogged && !isPersonalRoute) {
      routeUrl = '/services-without-registration/payment-area/cart';
    }
    return routeUrl;
  }
  // readonly getRoute = (isPersonalRoute: boolean) => isPersonalRoute ?
  //   '/personal/payment-area/cart' :
  //   '/services-without-registration/payment-area/cart'

  ngOnInit(): void {
    const footerEmailModalId = 'inserimentoEmailAnonimoModal';
    const footerEmailModalEl: any = document.getElementById(footerEmailModalId);
    footerEmailModalEl.addEventListener('hidden.bs.modal', (event: any) => {
      $("body").removeClass("overflow-hidden");
      $(".gb-popup[data-tipo='" + footerEmailModalId + "']").addClass("d-none");
    })
  }

  deleteDebtPosition() {
    this.debtPositionsService.deleteDebtPosition();
  }
  logoutAndGoToHome() {
    this.cartService.svuotaTuttiICarrelli(this.storeService.authority?.codiceIpaEnte ?? '');
    this.authService.logoutAndGoHome();
  }
  loginAndNavigate() {
    this.cartService.svuotaTuttiICarrelli(this.storeService.authority?.codiceIpaEnte ?? '');
    this.authService.navigateToLoginPage();
  }
  logoutAndGoServiceWithoutRegistration() {
    this.authService.logoutAndGoServiceWithoutRegistration();
  }
  deletePersonalData() {
    this.userService.deleteProfileAndPersonalArea()
      .subscribe(() => this.authService.logoutAndGoHome());
  }
  onAddEmail() {
    const email = this.anonimousEmailForm?.get('emailAddress')?.value;
    if(email != null && email != '') {
      this.storeService.emailUtentePagamentoAnonimo = email;
      // Close modal
      const footerEmailModalId = 'inserimentoEmailAnonimoModal';
      $("body").removeClass("overflow-hidden");
      $("#" + footerEmailModalId).addClass("d-none");
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
      $('body').removeAttr('style');
      // Confirm message
      this.toastr.info('La mail è stata aggiunta correttamente', 'Email aggiunta')
    }
  }
  // [x]: PAF
  closeExtendedFunctionalitiesPopup() {
    if(this.userService.userProfile != null) {
      this.userService.setUserExtendedFunctionality(this.userService.userProfile)
      .subscribe({
        next: (res: any) => {
          console.log('setUserExtendedFunctionality - res', res);
          if(res && res != null && res == true) {
            this.userService.userPagamentoVeloceFunctionality = false;
            this.userService.userAreaEstesaFunctionality = false;
          }
        },
        error: (error) => {
          console.log(error);
        }
      });
    }
  }
  userFunctionalityActivation(functionality: string) {
    console.log('userFunctionalityActivation', functionality);
    if (functionality == 'pagamentoVeloce') {
      this.debtPositionsService.activeFunctionalityUpdateUserProfile(functionality, true);
    }
    if (functionality == 'areaEstesa') {
      this.debtPositionsService.activeFunctionalityAndUpdatePositionAndProfile(functionality, true);
    }
  }
  userFunctionalityBothActivation() {
    this.debtPositionsService.activeFunctionalityUpdateUserProfile('pagamentoVeloce', true);
    setTimeout(() => {
      this.debtPositionsService.activeFunctionalityAndUpdatePositionAndProfile('areaEstesa', true);
    }, 0);
    // TODO - Non usata: verificare se serve e se i metodi precedenti funzionano
    // this.debtPositionsService.activeBothFunctionalities();
  }
}
